import styled from "styled-components";

export const DivMain = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-left: 0%;
  margin-top: 0px;
  height: 100%;
  border: 0px solid black;
  overflow: auto;
  font-family: ${(props) => props.theme.font.family.main};
`;
